import { render, staticRenderFns } from "./SubscriptionPayments.vue?vue&type=template&id=4c5e83a4&scoped=true&"
import script from "./SubscriptionPayments.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPayments.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPayments.vue?vue&type=style&index=0&id=4c5e83a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5e83a4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c5e83a4')) {
      api.createRecord('4c5e83a4', component.options)
    } else {
      api.reload('4c5e83a4', component.options)
    }
    module.hot.accept("./SubscriptionPayments.vue?vue&type=template&id=4c5e83a4&scoped=true&", function () {
      api.rerender('4c5e83a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/subscriptions/SubscriptionPayments.vue"
export default component.exports